import React from 'react';
import { Download } from 'lucide-react';
import cvFile from '../assets/TALLA_FOSSI_Florent_Martial_CV.pdf';
import SectionHeader from './SectionHeader';
import { EducationTimeline, ExperienceTimeline } from './PathTimeline';
import { useLocale } from '../context/LocaleContext';

const HomePathSection = ({
  id = 'parcours',
  sectionClassName = 'rihen-section rihen-section--surface home-path-section',
}) => {
  const { t } = useLocale();

  return (
    <section className={sectionClassName} id={id}>
      <div className="rihen-site-inner">
        <div className="home-path-section__layout">
          <div className="home-path-section__primary">
            <SectionHeader
              eyebrow={t('home_section_journey_badge')}
              title={t('home_section_journey_title_line1')}
              titleLine2={t('home_section_journey_title_line2')}
              titleClassName="hero-manifest__title hero-manifest__title--on-surface"
              subtitle={t('home_section_journey_subtitle')}
              centered={false}
              className="home-path-section__head"
            />

            <a
              href={cvFile}
              download="TALLA_FOSSI_Florent_Martial_CV.pdf"
              className="rihen-btn rihen-btn-teal interactive-button home-path-section__cv inline-flex w-fit items-center"
              data-reveal
            >
              <Download size={18} />
              {t('foot_cv_btn')}
            </a>

            <div className="home-path-section__group">
              <h3 className="home-path-section__label" data-reveal="fade">
                {t('home_path_formation_label')}
              </h3>
              <EducationTimeline />
            </div>
          </div>

          <div className="home-path-section__experience">
            <h3 className="home-path-section__label" data-reveal="fade">
              {t('home_path_experience_label')}
            </h3>
            <ExperienceTimeline />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomePathSection;
